const { REACT_APP_API_PLACEHOLDER }   = process.env
export const FEEDBACK                 = REACT_APP_API_PLACEHOLDER + '/feedbacks'



// WEBPACK FOOTER //
// ./src/features/Feedback/apiConst.js